import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem, HeaderAction } from '@shared/components/navigation/types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * Breadcrumb del listado de reubicaciones con la acción "Nueva reubicación".
 * La acción navega a la sección de escaneo (/relocations/new) en lugar de abrir un modal.
 */
export const RelocationsBreadcrumb = () => {
  const { t } = useTranslation('relocationsModule');
  const navigate = useNavigate();

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const title = t('breadcrumb.relocations');
    return [{ label: title, title }];
  }, [t]);

  const handleCreate = useCallback(() => {
    navigate('/relocations/new');
  }, [navigate]);

  const headerActions = useMemo<HeaderAction[]>(
    () => [
      {
        id: 'create-relocation',
        label: t('actions.create'),
        onClick: handleCreate,
        variant: 'primary',
      },
    ],
    [handleCreate, t],
  );

  usePageNavigation({ breadcrumbs, headerActions });

  return null;
};
